import React, { useEffect, useRef, useState } from "react";
import { Menu, MenuButton, MenuItems, Transition } from "@headlessui/react";
import { usePopper } from "react-popper";
import { bottom, left, right, top } from "@popperjs/core";
import { classNames } from "../../../helpers/classNames";
import FlexibleSelect from "../../form/select/FlexibleSelect";
import DatePicker from "../../form/DatePicker";

const TableSearch = ({
  xPlacement,
  onSearchFilter = () => {},
  totalDataCount,
  keywordSearch = () => {},
  searchData,
  isOption = "select", //range-picker, datepicker, search, price-range, color-picker,
  ...props
}) => {
  const popperElRef = useRef(null);
  const buttonRef = useRef(null);
  const [targetElement, setTargetElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [selected, setSelected] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!keyword) {
      keywordSearch("");
    }
  }, [keyword]);

  const placements = {
    bottom: bottom,
    bottomLeft: "bottom-start",
    bottomRight: "bottom-end",
    top: top,
    topLeft: "top-start",
    topRight: "top-end",
    right: right,
    left: left,
    "": bottom,
  };
  const { styles, attributes } = usePopper(targetElement, popperElement, {
    placement: placements[xPlacement],
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 8],
        },
      },
    ],
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popperElRef.current &&
        !popperElRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Menu as="div">
      <>
        <div className="relative group">
          <MenuButton
            ref={(el) => {
              buttonRef.current = el;
              setTargetElement(el);
            }}
            className="flex items-center"
            onClick={() => setOpen(!open)}>
            <div
              className={classNames(
                "relative flex items-center gap-2 text-sm w-fit h-8 px-2 rounded-full text-slate-500 transition-all duration-300 ease-in-out bg-transparent",
                selected.length > 0 ? "text-primary" : ""
              )}>
              <i className="fa-solid fa-magnifying-glass text-[15px]"></i>

              {selected.length > 0 && (
                <div className="relative flex items-center gap-1 text-[16px] font-medium text-indigo-600 animate-fadeIn">
                  <span>{totalDataCount || 0}</span>
                  <sup
                    className="cursor-pointer text-[14px] text-rose-600 hover:text-red-700 transition-all -mt-2"
                    onClick={() => {
                      setSelected([]);
                      onSearchFilter([]);
                    }}
                    title="Clear Filter">
                    ×
                  </sup>
                </div>
              )}
            </div>
          </MenuButton>
        </div>
        <div className="relative">
          <Transition
            show={open}
            leave="transition duration-75"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            className="z-50"
            beforeEnter={() => setPopperElement(popperElRef.current)}
            afterLeave={() => setPopperElement(null)}
            ref={popperElRef}
            style={styles.popper}
            {...attributes.popper}>
            <MenuItems
              ref={popperElRef}
              className="w-72 origin-top-right text bg-white border border-gray-200 divide-y divide-gray-100 rounded-lg shadow-lg ring-0">
              <div className="absolute -top-2 left-32 w-4 h-4 rotate-45 bg-white border-l border-t border-gray-200 z-10"></div>
              <div className="py-2 max-h-60 divide-y text-black divide-gray-100">
                <div onClick={() => {}} className="cursor-pointer transition-all duration-200">
                  <div className="py-2 px-2 flex items-center justify-center gap-3 rounded-t-lg">
                    {isOption === "select" && (
                      <FlexibleSelect
                        selectedValue={selected}
                        type="multiple"
                        isSearch
                        onSearchHandler={(val) => {
                          setKeyword(val);
                          keywordSearch(val);
                        }}
                        searchValue={keyword}
                        isDropdownOpen={open}
                        dropdownData={searchData || []}
                        onChange={(val) => {
                          setSelected(val);
                          onSearchFilter(val);
                        }}
                      />
                    )}
                    {isOption === "range-picker" && (
                      <DatePicker
                        placeholder={"Select Date Range"}
                        position="absolute"
                        value={selected}
                        onChange={(val) => {
                          setSelected(val);
                          onSearchFilter(val);
                        }}
                        renge={true}
                      />
                    )}
                  </div>
                </div>
              </div>
            </MenuItems>
          </Transition>
        </div>
      </>
    </Menu>
  );
};

export default TableSearch;
